import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';
@Pipe({
    name: 'msgpopup'
})
export class MsgPopupPipe implements PipeTransform {

    constructor(
        private commonService: CommonService
    ) { }
    transform(msg:string, action:string = "x", csClass:string = ""): string {
        this.commonService.showSnakeBar(msg);
        return msg;
    }
}  